export enum BarChartFilter {
  nessun_filtro = 'nessun_filtro',
  data_pagamento = 'data_pagamento',
  data_scadenza = 'data_scadenza',
  data_emissione = 'data_emissione'
}
